// src/screens/GmailOAuthCallback.js
import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import request from '../utils/request';
import { setAdminInfo, setToken } from '../store/slices/adminSlices';

export default function GmailOAuthCallback() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { search } = useLocation(); // "?code=…&state=…"

  useEffect(() => {
    (async () => {
      try {
        await request.get(`/hosts/oauth/callback${search}`, { withCredentials: true });
        const auth = await request.get('/auth/me', { withCredentials: true });
        if (auth.data?.user) {
          dispatch(setAdminInfo(auth.data.user));
        }
        if (auth.data?.token) {
          dispatch(setToken(auth.data.token));
        }
        // on success, manually drive the user home
        navigate('/settings');
      } catch (err) {
        console.error('OAuth callback failed', err);
        navigate('/settings?error=1');
      }
    })();
  }, [dispatch, search, navigate]);

  return (
    <div className="p-6 flex items-center justify-center text-[#6B7280]">
      Finalizing Gmail connection…
    </div>
  );
}
